import { useState } from 'react';

import type { SortDirection } from '@src/packages/dashboard/components/ReportSummary/types';

/**
 * Sort order of the template rankings. Lives above the summary because the PDF
 * export has to list the templates in the same order the user is seeing.
 */
export const useTasksSummarySort = () => {
  const [executionSort, setExecutionSort] = useState<SortDirection>('desc');
  const [complianceSort, setComplianceSort] = useState<SortDirection>('asc');

  return {
    executionSort,
    complianceSort,
    onExecutionSortChange: setExecutionSort,
    onComplianceSortChange: setComplianceSort,
  };
};

export type TasksSummarySort = ReturnType<typeof useTasksSummarySort>;
